import { useEffect } from "react";
import { LegalPage } from "@/components/landing/LegalPage";

export default function Datenschutz() {
  useEffect(() => {
    document.title = "Datenschutzerklärung — Positivup";
  }, []);
  return <LegalPage doc="datenschutz" />;
}
